import './header-menu-bar.scss';
import './header-menu-tray.scss';

import { components } from 'gridstrap/lib/gs-components';

import { GSHeaderMenuBar } from './header-menu-bar';
import { GSHeaderMenuTray } from './header-menu-tray';


components.register({
	selector: '.gs-HeaderMenuBar',
	controller: GSHeaderMenuBar
});

components.register({
	selector: '.gs-HeaderMenuTray',
	controller: GSHeaderMenuTray
});
